import getLocalStorageKey from './getLocalStorageKey';
import isLocalStorageSupported from './isLocalStorageSupported';

/**
 * Removes the item from localStorage.
 */
const removeItem = (key: string) => {
    if (isLocalStorageSupported()) {
        const localStorageKey = getLocalStorageKey(key);
        window.localStorage.removeItem(localStorageKey);
    }
};

export default removeItem;
